import React,{ useState, useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { StaticContext } from 'react-router'
import { MatchParams } from '../types'
import { useForm } from 'react-hook-form'
import { getListInfo, sendAuthEmail } from '../../lib/api/subscriber'
import Alert from '../../components/Alert/Alert'
import { Helmet } from 'react-helmet'

type emailLoginForm = {
  email: string
}

type locationState ={
  detail:string
}

function EmailLogin (props:RouteComponentProps<MatchParams,StaticContext,locationState>) {

  const { listId  } = props.match.params
  const [ listName, setListName ] = useState('')
  const [ sent, setSent ] = useState(false)
  const [ email, setEmail ] = useState('')
  const [ showAlert, setShowAlert ] = useState(false)

  //주소록 이름 적용
  useEffect(()=>{
    //토큰으로 인해 튕기는 경우 얼럿창 표시
    if(props.location.state?.detail === 'Errors.Authorization.NoToken' || props.location.state?.detail === 'tokenError' || props.location.state?.detail === 'Errors.List.NotExistEmail' || props.location.state?.detail === 'Errors.List.EditUnsubscribedSubscriber'){
      setShowAlert(true)
      setTimeout(()=>{
        setShowAlert(false)
      },3000)
    }
    getListInfo({listId:listId}).then(res=>setListName(res.data.listName))
  },[])

  const parsedEmail = window.location.search.substring(1).split('=')[1]
  const { register, handleSubmit, errors, setError } = useForm<emailLoginForm>({defaultValues:{email:parsedEmail||''}})

  const onSubmit = (data:emailLoginForm)=>{
    const encodedEmail = data.email.replace(/\+/gi,"%2b")
    sendAuthEmail({listId:listId,subscriber:encodedEmail}).then(()=>{
      setEmail(data.email)
      setSent(!sent)
    }).catch((e)=>{
      setError('email',{type:'serverValidation',message:e.response.data.Message})
      console.log(e.response.data.Message)
    })
  }

  return (
    <>
    <Helmet>
      <title>{listName} 구독 정보 변경하기</title>
    </Helmet>
      <div className="form-frame-subscriber">
        <div className="inner">
          <div id="stb_subscriber">
            <div className="stb_subscriber_header">

              <h1>{listName}<br/>구독 정보 변경하기</h1>
            </div>

            <div className="stb_subscriber_description"> 
            {sent?
              "아래의 이메일 주소로 구독 정보를 변경할 수 있는 링크를 보내드렸습니다. 링크는 24시간 뒤에 만료됩니다."
              :
              "구독 중인 이메일 주소를 입력하세요. 구독 정보를 변경할 수 있는 링크를 이메일로 보내드립니다."
            }
            </div>

            
            <form onSubmit={handleSubmit(onSubmit)} method="POST" target="_blank" acceptCharset="utf-8" className="stb_form" name="stb_subscribe_form" id="stb_subscriber_form" noValidate>
              <div className='stb_subscriber_field email_login'>
              {sent?
                <div className='email_info'>
                  {email}
                </div>
                :
                <>
                  <fieldset className="stb_form_set">
                    <label>
                      이메일 주소
                    </label>
                    <input type="email" className="stb_form_set_input" name='email' ref={register({required:true, pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/})} ></input>
                      {errors.email?.type === 'required' && <div className="stb_form_msg_error">이메일 주소를 입력하세요.</div>}
                      {errors.email?.type === 'pattern' && <div className="stb_form_msg_error">잘못된 이메일 주소입니다.</div>}
                      {errors.email?.type === 'serverValidation' &&<div className="stb_form_msg_error">{errors.email.message}</div>}
                  </fieldset>
                  <fieldset className="stb_form_set">
                    <button type="submit" className="stb_form_submit_button auth btn primary link">구독 정보 변경 링크 보내기</button>
                  </fieldset> 
                </>
                }
              </div>
            </form>
          </div>
        </div>
      </div>
      <Alert msg='이런, 뭔가 문제가 있는 것 같습니다.' show={showAlert}/>
    </>
  )
}

export default EmailLogin